import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from '../locales/es.json';
import en from '../locales/en.json';

/**
 * i18next Configuration for Multi-language Support
 * Supports Spanish (es) and English (en)
 */

const resources = {
  es: { translation: es },
  en: { translation: en }
};

i18n
  // Detect user's language preference
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language (English)
    lng: 'en', // Initial language
    interpolation: {
      escapeValue: false // React already handles XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
